import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f767fc36"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "no-mb"
}

import { computed, onMounted, ref } from 'vue'
import { ls } from '@/ls'
import axios from 'axios'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsWidget',
  setup(__props) {

const router = useRouter()
const building = computed(() => ls.get('building'))

const loading = ref(false)
const news = ref([])

onMounted(() => {
  getNews()
})

function getNews () : void {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/news').then((r) => {
    news.value = r.data
  }).finally(() => {
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "Nieuws" }, {
    default: _withCtx(() => [
      (news.value.length)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 0,
            style: {"margin-bottom":"0"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_list, {
                    "item-layout": "horizontal",
                    "data-source": news.value,
                    size: "small",
                    pagination: news.value.length > 5 ? { pageSize: 5, size: 'small', style: { textAlign: 'left' } } : false
                  }, {
                    renderItem: _withCtx(({ item }) => [
                      _createVNode(_component_a_list_item, {
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (_unref(router).push({ name: 'NewsItem', params: { newsId: item.id }}))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_list_item_meta, {
                            class: "clickable",
                            style: {"font-weight":"500","line-break":"anywhere"}
                          }, _createSlots({
                            avatar: _withCtx(() => [
                              (item.img)
                                ? (_openBlock(), _createBlock(_component_a_avatar, {
                                    key: 0,
                                    shape: "square",
                                    size: 50,
                                    src: item.img.url
                                  }, null, 8, ["src"]))
                                : (_openBlock(), _createBlock(_component_a_avatar, {
                                    key: 1,
                                    shape: "square",
                                    size: 50,
                                    src: _unref(building).projectLogo ? _unref(building).projectLogo.url : '/img/logos/Woonon_Square_Logo.png'
                                  }, null, 8, ["src"]))
                            ]),
                            title: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, [
                            (item.published_at)
                              ? {
                                  name: "description",
                                  fn: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(new Date(item.published_at).toLocaleDateString('nl-NL')), 1)
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["data-source", "pagination"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_a_row, {
            key: 1,
            style: {"margin-bottom":"0"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  (loading.value)
                    ? (_openBlock(), _createBlock(_component_a_skeleton, {
                        key: 0,
                        active: ""
                      }))
                    : (_openBlock(), _createElementBlock("p", _hoisted_1, "Er zijn (nog) geen nieuwsberichten."))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}
}

})